module.exports = __webpack_public_path__ + "media/images/bg/honeycombs-green-c74e7d57dd014f118e920e88e05e98b8.svg";